/* eslint-disable */
export var ConversationCommandType;
(function (ConversationCommandType) {
    ConversationCommandType[ConversationCommandType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    ConversationCommandType[ConversationCommandType["RESUME"] = 1] = "RESUME";
    ConversationCommandType[ConversationCommandType["LAUNCH"] = 2] = "LAUNCH";
    ConversationCommandType[ConversationCommandType["QUIT"] = 3] = "QUIT";
    ConversationCommandType[ConversationCommandType["ROUTINE"] = 4] = "ROUTINE";
    ConversationCommandType[ConversationCommandType["SWITCH"] = 5] = "SWITCH";
})(ConversationCommandType || (ConversationCommandType = {}));
export function conversationCommandTypeFromJSON(object) {
    switch (object) {
        case 0:
        case "CONVERSATION_COMMAND_TYPE_UNSPECIFIED":
            return ConversationCommandType.UNSPECIFIED;
        case 1:
        case "CONVERSATION_COMMAND_TYPE_RESUME":
            return ConversationCommandType.RESUME;
        case 2:
        case "CONVERSATION_COMMAND_TYPE_LAUNCH":
            return ConversationCommandType.LAUNCH;
        case 3:
        case "CONVERSATION_COMMAND_TYPE_QUIT":
            return ConversationCommandType.QUIT;
        case 4:
        case "CONVERSATION_COMMAND_TYPE_ROUTINE":
            return ConversationCommandType.ROUTINE;
        case 5:
        case "CONVERSATION_COMMAND_TYPE_SWITCH":
            return ConversationCommandType.SWITCH;
        default:
            throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum ConversationCommandType");
    }
}
export function conversationCommandTypeToJSON(object) {
    switch (object) {
        case ConversationCommandType.UNSPECIFIED:
            return "CONVERSATION_COMMAND_TYPE_UNSPECIFIED";
        case ConversationCommandType.RESUME:
            return "CONVERSATION_COMMAND_TYPE_RESUME";
        case ConversationCommandType.LAUNCH:
            return "CONVERSATION_COMMAND_TYPE_LAUNCH";
        case ConversationCommandType.QUIT:
            return "CONVERSATION_COMMAND_TYPE_QUIT";
        case ConversationCommandType.ROUTINE:
            return "CONVERSATION_COMMAND_TYPE_ROUTINE";
        case ConversationCommandType.SWITCH:
            return "CONVERSATION_COMMAND_TYPE_SWITCH";
        default:
            throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum ConversationCommandType");
    }
}
var tsProtoGlobalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof global !== "undefined") {
        return global;
    }
    throw "Unable to locate global object";
})();
